export default {
  // 获取当前月期第一天
  GetMonthFirstDateTime: function () {
    var mydate = new Date();
    return mydate.getFullYear() + "-" + (mydate.getMonth() + 1) + "-01 00:00:00";
  },
  // 获取当前月期最后一天
  GetMonthLastDateTime: function () {
    var mydate = new Date();
    var new_year = mydate.getFullYear(); //取当前的年份
    var new_month = (mydate.getMonth() + 1) //取下一个月的第一天，方便计算（最后一天不固定） 
    var new_date = new Date(new_year, new_month, 1);

    var date_count = (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月的天
    return mydate.getFullYear() + "-" + (mydate.getMonth() + 1) + "-" + date_count + " " + 23 + ":" + 59 + ":" + 59;
  },
  // 日期格式化，例：DateFormat(new Date(),'yyyy-MM-dd hh:mm:ss')
  DateFormat: function (date, fmt) { //author: meizz   
    var o = {
      "M+": date.getMonth() + 1, //月份   
      "d+": date.getDate(), //日   
      "h+": date.getHours(), //小时   
      "m+": date.getMinutes(), //分   
      "s+": date.getSeconds(), //秒   
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
      "S": date.getMilliseconds() //毫秒   
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
}



// WEBPACK FOOTER //
// ./src/Common/CommonMethods.js